import { checkValidEmail } from '../helpers/form-validation';

const DownloadReport = () => {
  const report = document.querySelector('.download-request');
  const prevDownloads = localStorage.getItem('reports');
  let hasFileDownloaded = false;
  let currentFile;
  let currentFileName;
  let currentFileType;

  if (hasFileDownloaded) {
    handleDownload();
  }

  if (report) {
    const form = report.querySelector('form');
    const downloadBtn = report.querySelector('.download-button');
    const downloadLink = report.querySelector('.download-link');
    currentFile = report.getAttribute('data-file');
    currentFileName = report.getAttribute('data-filename');
    currentFileType = report.getAttribute('data-filetype');
    hasFileDownloaded = prevDownloads && prevDownloads.split(',').indexOf(currentFile);

    if (form) {
      const formInputControls = form.querySelectorAll('input[type=text]');
      const formSelectButtons = form.querySelectorAll('.gfield_select');
      const requiredFields = form.querySelectorAll('.gfield_contains_required');
      const submitBtn = form ? form.querySelector('.gform_button') : null;

      formInputControls.forEach(control => {
        control.addEventListener('focus', onFocus);
        control.addEventListener('blur', onBlur);
      });

      formSelectButtons.forEach(select => {
        select.closest('.gfield').classList.add('is-form-select');
      });

      // On submitting the form
      // Validate empty fields and inputted email address
      if (submitBtn) {
        submitBtn.addEventListener('click', e => {
          e.preventDefault();

          requiredFields.forEach(field => {
            const input = field.querySelector('input[type=text]');

            if (input) {
              const value = input.value;

              if (value === '') {
                field.classList.add('has-error');
                return false;
              }

              if (input.parentNode.classList.contains('ginput_container_email')) {
                if (! checkValidEmail(value)) {
                  field.classList.add('has-error');
                  return false;
                }
              }

              field.classList.remove('has-error');
            }
          });

          form.submit();
        });
      }
    }

    // On Clicking Download Button or Link
    downloadBtn.addEventListener('click', handleDownload);
    downloadLink.addEventListener('click', handleDownload);
  }

  function handleDownload() {
    const downloads = [];

    if (prevDownloads) {
      downloads.push(prevDownloads);
    }

    if (! hasFileDownloaded) {
      downloads.push(currentFile);
      localStorage.setItem('reports', downloads);
    }

    report.classList.add('has-downloaded');

    window.dataLayer.push({
      event: 'download',
      eventType: 'asset download click',
      assetType: currentFileType,
      contentTitle: currentFileName,
    });
  }

  function onFocus(e) {
    e.target.closest('.gfield').classList.add('has-focus');
  }

  function onBlur(e) {
    e.target.closest('.gfield').classList.remove('has-focus');

    checkValue(e);
  }

  function checkValue(e) {
    const target = e.target || e;
    const formInput = target.closest('.gfield');
    const { value } = target;

    if (value !== '') {
      formInput.classList.add('has-value');
      formInput.classList.remove('has-error');
    } else {
      formInput.classList.remove('has-value');
      formInput.classList.add('has-error');
    }

    if (target.closest('.ginput_container').classList.contains('ginput_container_email')) {
      if (! checkValidEmail(value)) {
        formInput.classList.add('has-error');
      } else {
        formInput.classList.remove('has-error');
      }
    }
  }
};

export default DownloadReport;
